import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

import { DocketEntryTypeNotificationsActions } from './partials/notifications'

export const DocketEntryTypeActions = {
  ...DocketEntryTypeNotificationsActions,

  getDocketEntryTypes: async ({ commit }, filters) => {
    return axiosRequest.
      get('/docket_entry_types', { params: filters }).
      then(({ data }) => commit('setDocketEntryTypes', data)).
      catch(handleError)
  },
}
